import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";
import Modal from "react-modal";

const ContainerLoadingForm = (props) => {
  const frmRef = useRef({});
  const [loading, setLoading] = useState(false);
  const productRef = useRef({});

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  var dateString =
    d.getDate() +
    "/" +
    (d.getMonth() + 1) +
    "/" +
    d.getFullYear() +
    " " +
    d.getHours() +
    ":" +
    d.getMinutes() +
    ":" +
    d.getSeconds();
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const [productDetails, setProductDetails] = useState([]);
  const [close, setClose] = useState(false);

  const [employeelist, setEmployeelist] = useState(null);
  const [assignEmployeeId, setAssignEmployeeId] = useState();
  const rangeRef = useRef({});
  const [rangeDetails, setRangeDetails] = useState([]);
  const [rangeClose, setRangeClose] = useState(false);
  const [unlaodpalletList, setunlaodpalletList] = useState();
  const [remainingUnlaodpalletList, setremainingUnlaodpalletList] = useState();
  const [selectedUnlaodpalletList, setselectedUnlaodpalletList] = useState([]);
  const [fromPalletListId, setfromPalletListId] = useState();
  const [toPalletListId, settoPalletListId] = useState();

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
      left: 40,
    },
    content: {
      top: "50%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "900px",
      minHeight: "500px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const { sendRequest: getEmp } = useHttp();
  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=Warehouse&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        // //console.log("emp", data.output);
        setEmployeelist(data.output);
      }
    );
  }, [getEmp]);

  const { sendRequest: getemptypalletList } = useHttp();

  useEffect(() => {
    getemptypalletList(
      {
        url: `/api/unlaodpalletList/?warehouseId=${localStorage.getItem(
          "warehouseId"
        )}`,
      },
      (res) => {
        if (res) {
          // //console.log("PalletList", res.PalletList);

          setunlaodpalletList(res.PalletList);
          setremainingUnlaodpalletList(res.PalletList);
        }
      }
    );
  }, [getemptypalletList]);

  const { sendRequest: postContainerLoading } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();
    setLoading(true);

    const data = {
      containerLoadingDate: moment(frmRef.current.date.value).format(
        "DD/MM/YYYY"
      ),
      supervisorEmployeeId: assignEmployeeId,
      timeStamp: frmRef.current.packingTime.value,
      containerType: frmRef.current.container_type.value,
      containerNo: frmRef.current.container_number.value,
      palletIdRange: rangeDetails,
      containerTemperatue: frmRef.current.container_temp.value,
      sealNo: frmRef.current.seal_number.value,
      ventilation: frmRef.current.ventilation.value,
      humidityRelativeRange: frmRef.current.humidity_relative_range.value,
      maxHumiditySettings: frmRef.current.max_humidity_settings.value,
      shelfLife: frmRef.current.shelf_life.value,
      remark: frmRef.current.remark.value,
      status: 1,
      createdBy: parseInt(localStorage.getItem("id")),
      createdDate: dateString,
      orgId: localStorage.getItem("orgId"),
      warehouseId: parseInt(localStorage.getItem("warehouseId")),
      serviceId: props.sId,
    };
    if (props.update) {
      data["clId"] = props.update.clId;
    }
 
    postContainerLoading(
      {
        url: "/api/containerLoading/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
     
        props.addForm(false);
        setLoading(false);
      },
      (error) => {
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    //  // //console.log(props.update);

    if (props.update) {
      frmRef.current.date.value = moment(props.update.clDate).format(
        "YYYY-MM-DD"
      );
      frmRef.current.emp_id.value = props.update.SupervisorEmployeeId;
      frmRef.current.time_stamp.value = moment(
        props.update.timeStamp,
        "HH:mm"
      ).format("hh:mm");
      setProductDetails(props.update.productDetails);
      frmRef.current.container_number.value = props.update.containerNo;
      setRangeDetails(props.update.palletIdRange);
      frmRef.current.container_type.value = props.update.containerType;
      frmRef.current.seal_number.value = props.update.sealNo;
      frmRef.current.ventilation.value = props.update.ventilation;
      frmRef.current.humidity_relative_range.value =
        props.update.humidityRelativeRange;
      frmRef.current.max_humidity_settings.value =
        props.update.maxHumiditySettings;
      frmRef.current.container_temp.value = props.update.containerTemperatue;
      frmRef.current.shelf_life.value = props.update.shelfLife;
      frmRef.current.remark.value = props.update.remark;
    }
  }, [props.update]);
  const submitProduct = (e) => {
    e.preventDefault();
    setProductDetails((x) => [
      ...x,
      {
        srno:
          productDetails.length > 0
            ? productDetails[productDetails.length - 1].srno + 1
            : 1,

        itemDescription: productRef.current.itemDescription.value,
        itemType: productRef.current.itemType.value,
        itemCategory: productRef.current.itemCategory.value,
        itemQuantity: productRef.current.itemQuantity.value,
        unit: productRef.current.unit.value,
      },
    ]);

    // //console.log(productDetails);
  };

  const handleDelete = (index, e) => {
    setProductDetails(productDetails.filter((v, i) => i !== index));
  };

  const submitRange = (e) => {
    e.preventDefault();

    var i = 0;
    var newremainingPallet = [];
    var newselectedpallet = rangeDetails;

    var selecteditem = 0;

    var count = remainingUnlaodpalletList.length;
    var qty = 0;
    // //console.log("count", count);
    do {
      if (selecteditem == 0) {
        if (remainingUnlaodpalletList[i].palletListId == fromPalletListId) {
          newselectedpallet = newselectedpallet.concat(
            remainingUnlaodpalletList[i]
          );
          selecteditem = 1;
          qty++;
        } else {
          newremainingPallet = newremainingPallet.concat(
            remainingUnlaodpalletList[i]
          );
        }
      } else {
        newselectedpallet = newselectedpallet.concat(
          remainingUnlaodpalletList[i]
        );

        qty++;

        if (remainingUnlaodpalletList[i].palletListId == toPalletListId) {
          selecteditem = 0;
        }
      }

      i++;
    } while (count > i);
    // //console.log("newremainingPallet", newremainingPallet);
    setremainingUnlaodpalletList(newremainingPallet);
    setselectedUnlaodpalletList(newselectedpallet);

    // setRangeDetails((x) => [
    //   ...x,
    //   {
    //     palletListId: newselectedpallet[k].palletListId,
    //     palletNo: newselectedpallet[k].palletNo,
    //     // fromPackedId: fromPackedId,
    //     // toPackedId: toPackedId  ,
    //     // productDetails:boxDetail1 ,
    //     // productId:lotitem.productId,
    //     // itemQuantity:qty,
    //     // unitId:lotitem.unitId,
    //     // productCost:0,
    //     status: 1,
    //     createdBy: parseInt(localStorage.getItem("id")),
    //     createdDate: dateString,
    //     orgId: localStorage.getItem("orgId"),
    //   },
    // ]);

    setRangeDetails(newselectedpallet);
    // //console.log("rangeDetails", rangeDetails);
  };

  const handleRangeDelete = (index, e) => {
    setRangeDetails(rangeDetails.filter((v, i) => i !== index));
  };

  function getCurrentTime() {
    const now = new Date();
    let hours = now.getHours();
    let minutes = now.getMinutes();

    // Format hours and minutes with leading zeros if necessary
    hours = hours.toString().padStart(2, "0");
    minutes = minutes.toString().padStart(2, "0");

    return `${hours}:${minutes}`;
  }

  return (
    <>
      {close && (
        <Modal isOpen={close} style={customModalStyles}>
          <div>
            <div className="">
              <div className="">
                <h3 className="card-title">Product Details</h3>
                <div className="card-tools text-right">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => setClose(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                  <hr />
                </div>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-md-3">
                <label htmlFor={"srno"}> Sr. No</label>
                <span className={"input-prod"}>
                  {productDetails.length > 0
                    ? Number(
                        `${productDetails[productDetails.length - 1].srno}`
                      ) + 1
                    : 1}
                </span>
              </div>
              <div className="col-md-3">
                <label htmlFor={"itemId"}> Item Id</label>
                <input
                  type={"input"}
                  id={"itemId"}
                  required
                  ref={(el) => (productRef.current["itemId"] = el)}
                  className="form-control"
                />
              </div>
              <div className="col-md-3">
                <label htmlFor={"itemDescription"}> Item Description</label>
                <input
                  type={"input"}
                  id={"itemDescription"}
                  required
                  ref={(el) => (productRef.current["itemDescription"] = el)}
                  className="form-control"
                />
              </div>
              <div className="col-md-3">
                <label htmlFor={"itemType"}> Item Type</label>
                <input
                  type={"input"}
                  id={"itemType"}
                  required
                  ref={(el) => (productRef.current["itemType"] = el)}
                  className="form-control"
                />
              </div>
              <div className="col-md-3">
                <label htmlFor={"itemCategory"}> Item Category</label>
                <input
                  type={"input"}
                  id={"itemCategory"}
                  required
                  ref={(el) => (productRef.current["itemCategory"] = el)}
                  className="form-control"
                />
              </div>
              <div className="col-md-3">
                <label htmlFor={"itemQuantity"}> Item Quantity</label>
                <input
                  type={"number"}
                  id={"itemQuantity"}
                  required
                  ref={(el) => (productRef.current["itemQuantity"] = el)}
                  className="form-control"
                />
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-md-3">
                <label htmlFor={"unit"}>Unit</label>
                <select
                  id="unit"
                  className="drop-prod inputs"
                  ref={(el) => (productRef.current["unit"] = el)}
                  required
                >
                  <option value="Number">Number</option>
                  <option value="Miligram">Miligram</option>
                  <option value="Gram">Gram</option>
                  <option value="Kilogram">Kilogram</option>
                  <option value="Milliliter">Milliliter</option>
                  <option value="Liter">Liter</option>
                  <option value="Tons">Tons</option>
                </select>
              </div>
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <button className="product-add" onClick={submitProduct}>
                +
              </button>
              <button
                className="btn  btn-primary mx-2 my-2"
                onClick={(e) => {
                  e.preventDefault(false);

                  productDetails &&
                    productDetails.map((x) => (x["isSave"] = true));
                  setClose(false);
                }}
              >
                Save
              </button>
            </div>

            <hr />

            <table className="table table-bordered text-center">
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Item Id</th>
                  <th>Item Description</th>
                  <th>Item Type</th>
                  <th>Item Category/Variety</th>
                  <th>Item Quantity</th>
                  <th>Unit</th>
                </tr>
              </thead>
              <tbody>
                {productDetails &&
                  productDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{itm.srno}</td>
                        <td>{itm.itemId}</td>
                        <td>{itm.itemDescription}</td>
                        <td>{itm.itemType}</td>
                        <td>{itm.itemCategory}</td>
                        <td>{itm.itemQuantity}</td>
                        <td>{itm.unit}</td>

                        <td>
                          {" "}
                          <button
                            className="product-delete"
                            onClick={(e) => handleDelete(i, e)}
                          >
                            delete
                          </button>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </Modal>
      )}

      {rangeClose && (
        <Modal isOpen={rangeClose} style={customModalStyles}>
          <div>
            <div className="">
              <div className="">
                <h3 className="card-title">Product Details</h3>
                <div className="card-tools text-right">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => setRangeClose(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                  <hr />
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-md-3">
                <label htmlFor={"palletizationId"}>
                  {" "}
                  From Palletization No{" "}
                </label>
                <select
                  id="PalletizationId"
                  className="form-control"
                  ref={(el) => (frmRef.current["PalletizationId"] = el)}
                  value={fromPalletListId}
                  onChange={(e) => {
                    setfromPalletListId(e.target.value);
                  }}
                >
                  <option>--Select Palletization--</option>
                  {remainingUnlaodpalletList &&
                    remainingUnlaodpalletList.map((x) => (
                      <option value={x.palletListId}>{x.palletNo}</option>
                    ))}
                </select>
              </div>
              <div className="col-md-3">
                <label htmlFor={"palletizationId"}> To Palletization No </label>
                <select
                  id="PalletizationId"
                  className="form-control"
                  ref={(el) => (frmRef.current["PalletizationId"] = el)}
                  value={toPalletListId}
                  onChange={(e) => {
                    settoPalletListId(e.target.value);
                  }}
                >
                  <option>--Select Palletization--</option>
                  {remainingUnlaodpalletList &&
                    remainingUnlaodpalletList.map((x) => (
                      <option value={x.palletListId}>{x.palletNo}</option>
                    ))}
                </select>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-md-4"></div>
              <div className="col-md-1"></div>
              <div className="col-md-2">
                <button
                  className="btn  btn-primary mx-2 my-2"
                  onClick={submitRange}
                >
                  +
                </button>
              </div>
              <div className="col-md-1"></div>
              <div className="col-md-4"></div>
            </div>

            <hr />
            <div className="row mb-2">
              <table className="table table-bordered text-center">
                <thead>
                  <tr>
                    <th>Pallet No</th>
                    <th>Product Name</th>
                    <th>No Of Boxes</th>
                    <th>Product Subtype Name</th>
                    <th>Product Type Name</th>
                    {/* <th>Total gross Weight </th>
                <th>Total Net Weight </th> */}

                    <th>Delete </th>
                  </tr>
                </thead>
                <tbody>
                  {rangeDetails &&
                    rangeDetails.map((itm, i) => {
                      return (
                        <tr key={i}>
                          <td>{itm.palletNo}</td>
                          <td>{itm.palletProductDetail[0].productName}</td>
                          <td>{itm.palletProductDetail[0].boxQuantity}</td>
                          <td>
                            {itm.palletProductDetail[0].productSubTypeName}
                          </td>
                          <td>{itm.palletProductDetail[0].productTypeName}</td>
                          {/* <td>{itm.palletProductDetail[0].productSubTypeName}</td>
                      <td>{itm.palletProductDetail[0].productTypeName}</td> */}
                          <td>
                            <button
                              className="product-delete"
                              onClick={(e) => handleRangeDelete(i, e)}
                            >
                              delete
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>

            <div className="row mb-2">
              <div className="col-md-4"></div>
              <div className="col-md-1"></div>
              <div className="col-md-2">
                <button
                  className="btn  btn-primary mx-2 my-2"
                  onClick={() => {
                    rangeDetails.map((x) => (x["isSave"] = true));
                    setRangeClose(false);
                  }}
                >
                  Save
                </button>
              </div>
              <div className="col-md-1"></div>
              <div className="col-md-4"></div>
            </div>
          </div>
        </Modal>
      )}

      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Container Loading Details</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"date"}>{"Date "}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />{" "}
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"packing_time"}>
                        container Laoding Time
                      </label>

                      <input
                        type={"time"}
                        id={"packingTime"}
                        required
                        ref={(el) => (frmRef.current["packingTime"] = el)}
                        className="form-control"
                        defaultValue={getCurrentTime()}
                        onChange={(e) => {
                          // //console.log(e.target.value);
                          // setpackingTime(e.target.value);
                          // labelingRef.current.timeStamp.value=e.target.value;
                        }}
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"emp_id"}>{"Packhouse Employee"}</label>
                      <select
                        id="emp_id"
                        className="form-control"
                        ref={(el) => (frmRef.current["assignEmployeeId"] = el)}
                        value={assignEmployeeId}
                        onChange={(e) => {
                          setAssignEmployeeId(e.target.value);
                        }}
                      >
                        <option>--Select Employee--</option>
                        {employeelist &&
                          employeelist.map((x) => (
                            <option
                              key={x.empId}
                              employee-id={x.empId}
                              value={x.empId}
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"container_type"}>
                        {"Container Type"}
                      </label>
                      <select
                        id="container_type"
                        className="form-control"
                        ref={(el) => (frmRef.current["container_type"] = el)}
                      >
                        <option value="Reefer">Reefer</option>
                        <option value="Modified Atmosphere Reefer">
                          Modified Atmosphere Reefer
                        </option>
                        <option value="Controlled Atmosphere Reefer">
                          Controlled Atmosphere Reefer
                        </option>
                      </select>{" "}
                    </div>
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"container_number"}>
                        {"Container Number(No.) "}
                      </label>
                      <input
                        type={"text"}
                        id={"container_number"}
                        required
                        ref={(el) => (frmRef.current["container_number"] = el)}
                        className="form-control"
                      />{" "}
                    </div>
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"seal_number"}>
                        {"Seal Number(No.)"}
                      </label>
                      <input
                        type={"text"}
                        id={"seal_number"}
                        required
                        ref={(el) => (frmRef.current["seal_number"] = el)}
                        className="form-control"
                      />{" "}
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"product_details"}>
                        {" "}
                        {"Product Details"}
                      </label>
                      <br />
                      <button
                        className="btn btn-sm btn-success"
                        formNoValidate="True"
                        onClick={(e) => {
                          //console.log("Add Product");
                          e.preventDefault(false);
                          rangeDetails &&
                            setRangeDetails((items) =>
                              items.filter((x) => x.isSave)
                            );
                          setRangeClose(true);

                          // productDetails&& setProductDetails((items) => items.filter((x) => x.isSave));
                          // setClose(true);
                        }}
                      >
                        Add
                      </button>
                    </div>
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"ventilation"}>
                        {"Ventilation (air exchange)cbm/h "}
                      </label>
                      <input
                        type={"text"}
                        id={"ventilation"}
                        required
                        ref={(el) => (frmRef.current["ventilation"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"shelf_life"}>{"Shelf Life(days)"}</label>
                      <input
                        type={"text"}
                        id={"shelf_life"}
                        required
                        ref={(el) => (frmRef.current["shelf_life"] = el)}
                        className="form-control"
                      />{" "}
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-4">
                      <label htmlFor={"max_humidity_settings"}>
                        {"Max. humidity Settings"}
                      </label>
                      <select
                        id="max_humidity_settings"
                        className="form-control"
                        ref={(el) =>
                          (frmRef.current["max_humidity_settings"] = el)
                        }
                      >
                        <option value="On">On</option>
                        <option value="Off">Off</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"container_temp"}>
                        {"Container Temperature (°C) "}
                      </label>
                      <input
                        type={"text"}
                        id={"container_temp"}
                        required
                        ref={(el) => (frmRef.current["container_temp"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"humidity_relative_range"}>
                        {"Humidity relative % Range"}
                      </label>
                      <input
                        type={"text"}
                        id={"humidity_relative_range"}
                        required
                        ref={(el) =>
                          (frmRef.current["humidity_relative_range"] = el)
                        }
                        className="form-control"
                      />{" "}
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        required
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />{" "}
                    </div>
                    <div className="col-md-4"> </div>
                    <div className="col-md-4"> </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading}
                      >
                        {loading ? "Submitting..." : "Submit"}
                      </button>
                    </div>
                    <div className="col-md-1">
                      {/* <button className="btn  btn-primary mx-2 my-2" type="submit">
                Cancel
              </button> */}
                    </div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default ContainerLoadingForm;
